module.exports = __webpack_public_path__ + "static/media/banner_ecommerce02.1e1f972e.jpg";